import { Box, Card, Typography } from '@mui/material';

export const LeaveHistory = (): JSX.Element => {
	return (
		<Box flex="1">
			<Card>
				<Typography textAlign="center" height="calc(100vh - 165px)">
					Under Construction 🚧
				</Typography>
			</Card>
		</Box>
	);
};
